import React, { useContext } from "react"
import { Link } from "gatsby"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import styled from "styled-components"
import { GrCart } from "react-icons/gr"
import { GrFormPreviousLink } from "react-icons/gr"
import { CartContext } from "../context/CartContext"

const BackButton = styled.button`
    display: flex;
    align-items: flex-start;    
    font-size: 1.7em;
    font-family: inherit;
    /* padding: 7px; */
    background: #732619;
    color: white;
    border: none;
    cursor: pointer;
    /* box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    :hover, :active {
        box-shadow:none;
    } */
    svg {
        path {
            stroke: white;
        }
    }
`

const HeaderContainer = styled.div`
  background: #732619;
  margin-bottom: 1rem;
  position: fixed;
  width: 100%;
  z-index: 100;
`

const HeaderInfoContainer = styled.div`
  margin: 0 auto;
  max-width: 900px;
  padding: 0.2rem 0.7rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const LogoHolder = styled.div`
  display: flex;
`

const CartContainer = styled.div`
  svg {
    font-size: 1.6em;
    path {
      stroke: white;
    }
  }
`
const CartIcon = styled.span`
  background-color: #fff;
  border-radius: 50px;
  min-width: 23px;
  display: inline-block;
  vertical-align: center;
  text-align: center;
  color: #732619;
  margin-right: -5px;
`

const Header = ({ siteTitle }) => {
  const { cart } = useContext(CartContext)

let base_url = typeof window !== 'undefined' ? window.location.pathname : '';

  useStaticQuery(graphql`
    query {
      placeholderImage: file(relativePath: { eq: "baco-logo-blanco.png" }) {
        childImageSharp {
          fluid(
            maxWidth: 150
            traceSVG: { background: "#732619", color: "#fff" }
          ) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  let sumProductsQty = (acc, cur) => {
    return acc + cur.qty
  }
  let itemsInCart = 0
  itemsInCart = cart.reduce(sumProductsQty, 0)

  return (
    <HeaderContainer>
      <HeaderInfoContainer>
       <div style={{width:"1em"}}>
        { base_url !== '/' &&
          <BackButton  onClick={() => { window.history.back();}}>
            <GrFormPreviousLink/> 
          </BackButton> 
        }
        </div>        
        <div>  
          <Link to="/">
            <LogoHolder>
              {/* <Img fluid={data.placeholderImage.childImageSharp.fluid} /> */}
                <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="home" role="img" xmlns="http://www.w3.org/2000/svg" height="1.8em" width="1.8em" viewBox="0 0 576 512"><path fill="#fff" d="M280.37 148.26L96 300.11V464a16 16 0 0 0 16 16l112.06-.29a16 16 0 0 0 15.92-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.64a16 16 0 0 0 16 16.05L464 480a16 16 0 0 0 16-16V300L295.67 148.26a12.19 12.19 0 0 0-15.3 0zM571.6 251.47L488 182.56V44.05a12 12 0 0 0-12-12h-56a12 12 0 0 0-12 12v72.61L318.47 43a48 48 0 0 0-61 0L4.34 251.47a12 12 0 0 0-1.6 16.9l25.5 31A12 12 0 0 0 45.15 301l235.22-193.74a12.19 12.19 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0-1.7-16.93z"></path></svg>      
            </LogoHolder>
          </Link>
          </div>
        <Link to="/checkout">
          <div>
            <CartContainer>
              {itemsInCart !== 0 && <CartIcon>{itemsInCart}</CartIcon>}
              <GrCart />
            </CartContainer>
          </div>
        </Link>
      </HeaderInfoContainer>
    </HeaderContainer>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
